<template>
  <div :class="specialConsiderationClass">
    <span>
      <template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span>
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  fab
                  text
                  :style="{background: type === 1 ? '#03a9f4' : '#f44336'}"
                  class="specialBtn"
                  @click="haveNote"
              >SC</v-btn
              >
            </span>
          </template>
          <span>{{ title }}</span>
        </v-tooltip>
      </template>
    </span>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
      <v-card max-width="600px">
        <v-toolbar
            color="primary"
            dark
        >
          <span class="headline">Reason List</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row class="withdrawn-reason">
            <v-radio-group
                v-model="note"
            >
              <v-flex>
                <vue-perfect-scrollbar class="reason-radio-group">
                  <v-radio
                      v-for="(option, j) in notes"
                      color="primary"
                      :label="option.text"
                      :value="option"
                      :key="j"
                      class="reason-text"
                      @click="selectNote(option)"
                  ></v-radio>
                </vue-perfect-scrollbar>
              </v-flex>
            </v-radio-group>
          </v-layout>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="submitNote"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="otherType" max-width="600px" persistent>
      <v-card max-width="600px">
        <v-toolbar color="primary" dark>
          <span class="headline">Please input reason</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="otherType = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="m-t-20">
          <v-textarea
              outlined
              label="Reason"
              v-model="reasonValue"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="submitNote"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DataType, Popup, Tool } from '@/util/index'
import { OriginationApi } from '@/api/lms/origination-api'

const popup = new Popup()
const tool = new Tool()
export default {
  name: 'special-consideration-note',
  props: {
    loan: Object,
    operator: Object
  },
  data () {
    return {
      ResolutionFlags: {
        NOT_BE_HANDLED: 0,
        BEING_HANDLED: 1
      },
      specialConsiderationClass: '',
      showDialog: false,
      notes: DataType.SpecialConsiderationNote,
      note: null,
      option: {},
      title: 'Special Consideration',
      otherType: '',
      reasonValue: '',
      type: 1,
      id: null,
      locked: null
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    operatorData () {
      return this.operator
    }
  },
  watch: {
    loanId: {
      handler: function () {
        if (this.$route.path.includes(DataType.RouterPath.LOS_PATH)) {
          this.specialConsiderationClass = 'special-consideration-style'
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.$eventBus.$on('broadcastLockedId', target => {
      this.locked = target
      if (target === this.operatorData.id) {
        this.getSpecialConsideration(this.loan.id)
      }
    })
  },
  methods: {
    getSpecialConsideration (loanId) {
      const $this = this
      OriginationApi.getSpecialConsideration({ loanId: loanId }, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.id = result.id
          $this.type = 2
          $this.title = result.noteContent
        }
      })
    },
    selectNote (option) {
      this.option = option
      if (option.value === 14) {
        this.otherType = true
        this.showDialog = false
      }
    },
    submitNote () {
      const $this = this
      let input = {}
      if (this.option.value !== 14) {
        input = {
          loanId: this.loanId,
          scType: this.option.value,
          noteContent: this.option.text
        }
        OriginationApi.enableSpecialConsideration(input, function (result) {
          $this.showDialog = false
          $this.getSpecialConsideration($this.loanId)
          popup.popupForSuccess(result)
        }, function (err) {
          popup.popupForError(err.message)
        })
      } else {
        if (this.reasonValue === '') {
          popup.popupForInfo('Please enter a reason', null, function () {
            if (!$this.otherType) {
              $this.otherType = true
              $this.showDialog = false
            }
          })
        } else {
          input = {
            loanId: this.loanId,
            scType: this.option.value,
            noteContent: `${this.reasonValue}`
          }
          OriginationApi.enableSpecialConsideration(input, function (result) {
            $this.getSpecialConsideration($this.loanId)
            $this.otherType = false
            $this.showDialog = false
            $this.reasonValue = ''
            popup.popupForSuccess(result)
          }, function (err) {
            popup.popupForError(err.message)
          })
        }
      }
    },
    haveNote () {
      const $this = this
      if (this.locked === this.operatorData.id) {
        if (this.type === 1) {
          this.showDialog = true
        } else {
          const input = {
            loanId: this.loanId,
            id: this.id
          }
          popup.popupForQuestion('Are you sure to remove the reason selected previously?', { title: 'Please Confirm' }, function () {
            OriginationApi.disableSpecialConsideration(input, function (result) {
              popup.popupForSuccess(result)
              $this.type = 1
              $this.title = 'Special Consideration'
            }, function (err) {
              popup.popupForError(err.message)
            })
          })
        }
      } else {
        popup.popupForWarning('Current loan is locked by others')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.special-consideration-style {
  border-top-right-radius: 6px;
  display: block;
  position: relative;
  float: right;
  color: white;
  opacity: 0.88;
  height: 10px;
  margin-right: 10px;
  margin-top: 3px;
}
.group {
  display: flex;
  flex: 1;
  justify-content: space-around;
}
.specialBtn {
  width: 31px;
  height: 31px;
  line-height: 31px;
  color: #fff !important;
}
</style>
